import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import List from "./ListContainer";
import Pagination from "./PaginationContainer";
import Filter from "./FilterContainer";

import { init } from "../../../redux/actions/logActions";
import moment from "moment";

import { Link } from "react-router-dom";

class MainPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.init({});
  }

  render() {
    let fullWidth = "p-content-page-center-full";

    return (
      <Fragment>
        <div className={`p-content-page-center ${fullWidth}`}>
          <div className="p-content-page-center-header">
            <h2 className="p-content-page-center-header-title">Liste des logs envoyés</h2>
          </div>
          <div className="p-content-page-center-filters">
            <div className="p-mrg-right" style={{ width: 150 }}>
              <Filter
                filterTargetKey={"user_id"}
                placeholder={"Utilisateurs id"}
                defaultValue={this.props.currentFilters["user_id"]}
              />
            </div>
            {/* <div className="p-mrg-right" style={{ width: 230 }}>
              <RangePicker filterTargetKey={"period"} />
            </div> */}
          </div>
          <div className="p-content-page-center-content">
            <List
              columns={[
                {
                  title: "Utilisateur",
                  key: "userName",
                  sortable: true
                },

                {
                  title: "Titre",
                  key: "title"
                },
                {
                  title: "Message",
                  key: "msg"
                },
                {
                  title: "Date d'envoi",
                  key: "created_at",
                  render: (text, record, index) => {
                    return <div>{moment(record.created_at).format("DD/MM/YYYY HH:mm:ss")}</div>;
                  }
                },
                {
                  title: "user_id",
                  key: "user_id",
                  sortable: true
                },

                {
                  title: "version",
                  key: "version",
                  sortable: true
                },

                {
                  title: "Actions",
                  key: "actions",
                  sortable: false,
                  render: (text, record, index) => {
                    return (
                      <div style={{ height: 36, paddingTop: 11 }}>
                        <Link
                          to={{
                            pathname: `/log/preview/${record._id}`
                          }}
                        >
                          Voir
                        </Link>
                      </div>
                    );
                  }
                }
              ]}
            />
            <div className="p-al-right p-mrg-ver p-mrg-bot-l">
              <Pagination />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    logs: state.log.logs || [],
    currentPage: state.log.currentPage,
    totalPage: state.log.totalPage,
    hasNext: state.log.hasNext,
    currentSurveyId: state.log.currentFilters.surveyId,
    currentStartDate: state.log.currentFilters.startDate,
    currentPeriod: state.log.currentFilters.period,
    currentFilters: state.log.currentFilters
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    init: () => {
      dispatch(init());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);



// WEBPACK FOOTER //
// src/containers/activite/log/MainContainer.js